<app-base-modal
  [title]="titleModal()"
  [showStateToggle]="true"
>
  @if (isLoading) {
    <app-loader/>
  }
  <div
    class="header-modal"
    app-lf-header-modal
    [designBlockData]="designBlockData()"
    [columnKey]="modalKey()"
    [isActiveUploadFile]="isActiveUploadFile"
    (uploadFiles)="uploadFiles($event)"
  ></div>
  @if (!isShowFileLibrary()) {
    <app-carousel
      [itemsCount]="listingFilesStateService.listingFilesState().length"
      [gap]="20"
      [visibleItems]="3"
      (currentIndexChange)="onIndexChange($event)"
    >
      <div class="cards">
        @for (file of listingFilesStateService.listingFilesState(); track $index) {
          <div
            class="card"
            app-lf-file-card
            [file]="file"
            [listingEntityFileType]="listingEntityFileType()"
            [isEditModeActive]="isEditModeActive"
            (updateField)="updateField($event)"
          ></div>
        }
        @if (listingFilesStateService.listingFilesState().length < 3) {
          <app-file-upload-card
            class="card-upload"
            [fileUploadParams]="{
              recordId: designBlockData().id,
              parentId: designBlockData().id,
              type: listingEntityFileType(),
              entityFileType: listingEntityFileType()
            }"
            [isEditModeActive]="isEditModeActive"
            [remainingFileSlots]="remainingFileSlots()"
            (attachFile)="attachFile($event)"
          />
        }
      </div>
    </app-carousel>
  } @else {
    <app-listing-file-library
      [isEditModeActive]="isEditModeActive"
      (getFiles)="getFiles()"
    />
  }

  <div
    class="bottom-modal"
    [class.need-padding-inline]="!isShowFileLibrary()"
    app-lf-bottom-modal
    [designBlockData]="designBlockData()"
    [listingEntityFileType]="listingEntityFileType()"
    [isEditModeActive]="isEditModeActive"
    [isActiveUploadFile]="isActiveUploadFile"
    (updateComment)="updateComment($event)"
    (attachFile)="attachFile($event)"
  ></div>
</app-base-modal>
